"use strict";
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function setCookie(cname, cvalue, exdays) {
  const date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + date.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function deleteCookie(cname) {
  document.cookie = cname + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
/* [Modified by Codex at 2026-09-14] 避免动态更新后重复创建图片观察器 */
var BlsLazyloadImg = (function () {
  var imageObserver;

  function revealImage(image, bounds) {
    if (bounds?.width > 0 && bounds?.height > 0) {
      image.width = bounds.width;
      image.height = bounds.height;
      image.sizes = `${bounds.width}px`;
    }
    image.classList.add("bls-loaded-image");
    image.closest(".bls-image-js")?.classList.remove("bls-loading-image");
    delete image.dataset.vedressLazyObserved;
  }

  function collectImages(scope) {
    var root = scope || document;
    var images = [];

    if (root.matches?.(".bls-image-js img")) {
      images.push(root);
    }
    root.querySelectorAll?.(".bls-image-js img").forEach((image) => {
      images.push(image);
    });

    return images;
  }

  function getObserver() {
    if (!("IntersectionObserver" in window)) return null;
    if (imageObserver) return imageObserver;

    imageObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          revealImage(entry.target, entry.boundingClientRect);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "10px" },
    );

    return imageObserver;
  }

  return {
    init: function (scope) {
      this.lazyReady(scope || document);
    },
    lazyReady: function (scope) {
      var observer = getObserver();

      collectImages(scope).forEach((image) => {
        if (
          image.classList.contains("bls-loaded-image") ||
          image.dataset.vedressLazyObserved === "true"
        ) {
          return;
        }

        if (!observer) {
          revealImage(image, image.getBoundingClientRect());
          return;
        }

        image.dataset.vedressLazyObserved = "true";
        observer.observe(image);
      });
    },
  };
})();
/* [End] */
BlsLazyloadImg.init();
/* [Modified by Codex at 2026-09-11] 减少非首屏轮播初始化造成的主线程阻塞 */
var BlsSettingsSwiper = (function () {
  var carouselObserver;

  function isInitialized(element) {
    return (
      !element ||
      Boolean(element.swiper) ||
      element.dataset.vedressSwiperInitialized === "true"
    );
  }

  function collectCarousels(scope) {
    var elements = [];
    var root = scope || document;

    if (root.matches?.(".bls__swiper")) {
      elements.push(root);
    }
    root.querySelectorAll?.(".bls__swiper").forEach((element) => {
      elements.push(element);
    });

    return elements;
  }

  /* [Modified by Codex at 2026-10-12] 目标横幅同时启用响应式图片，保护首屏并支持视口切换 */
  function hydrateDeferredSlideImages(slide) {
    if (!slide) return;

    var images = slide.querySelectorAll("img[data-vedress-desktop-src]");
    images.forEach((image) => {
      var picture = image.closest("picture");
      var sources = Array.from(
        picture?.querySelectorAll("source[data-vedress-mobile-srcset]") || [],
      );
      var fallbackSrc = image.getAttribute("src");
      var fallbackSrcset = image.getAttribute("srcset");
      var desktopSrc = image.dataset.vedressDesktopSrc;
      var desktopSrcset = image.dataset.vedressDesktopSrcset;
      var mobileFallbacks = sources.map((source) => ({
        source,
        fallback: source.getAttribute("srcset"),
        real: source.dataset.vedressMobileSrcset,
      }));

      image.vedressSlideImageCleanup?.();
      var previousOpacity = image.style.opacity;
      var fallbackPicture = picture?.cloneNode(true);
      if (fallbackPicture) {
        fallbackPicture.setAttribute("aria-hidden", "true");
        fallbackPicture.style.pointerEvents = "none";
        fallbackPicture.querySelectorAll("source").forEach((source) => {
          source.removeAttribute("data-vedress-mobile-srcset");
        });
        fallbackPicture.querySelectorAll("img").forEach((placeholder) => {
          placeholder.removeAttribute("data-vedress-desktop-src");
          placeholder.removeAttribute("data-vedress-desktop-srcset");
          placeholder.alt = "";
          placeholder.loading = "eager";
        });
        picture.before(fallbackPicture);
        image.style.opacity = "0";
      }

      function restoreFallback() {
        image.removeEventListener("error", restoreFallback);
        mobileFallbacks.forEach(({ source, fallback, real }) => {
          source.srcset = fallback || "";
          source.dataset.vedressMobileSrcset = real;
        });
        image.srcset = fallbackSrcset || "";
        image.src = fallbackSrc;
        image.dataset.vedressDesktopSrc = desktopSrc;
        image.dataset.vedressDesktopSrcset = desktopSrcset;
      }

      function clearFallbackListeners() {
        image.removeEventListener("error", restoreFallback);
        image.removeEventListener("load", clearFallbackListeners);
        fallbackPicture?.remove();
        image.style.opacity = previousOpacity;
        if (image.vedressSlideImageCleanup === clearFallbackListeners) {
          delete image.vedressSlideImageCleanup;
        }
      }

      image.vedressSlideImageCleanup = clearFallbackListeners;
      image.addEventListener("error", restoreFallback, { once: true });
      image.addEventListener("load", clearFallbackListeners, { once: true });
      mobileFallbacks.forEach(({ source, real }) => {
        source.srcset = real;
        source.removeAttribute("data-vedress-mobile-srcset");
      });
      image.srcset = desktopSrcset;
      image.src = desktopSrc;
      image.removeAttribute("data-vedress-desktop-src");
      image.removeAttribute("data-vedress-desktop-srcset");
    });

    // 兼容尚未同步桌面延迟属性的旧 HTML 或编辑器区块。
    slide.querySelectorAll("source[data-vedress-mobile-srcset]").forEach((source) => {
      source.srcset = source.dataset.vedressMobileSrcset;
      source.removeAttribute("data-vedress-mobile-srcset");
    });
  }

  function hydrateAdjacentSlide(swiper, offset) {
    if (!swiper?.slides?.length) return;

    var targetIndex = swiper.activeIndex + offset;
    if (targetIndex < 0) targetIndex = swiper.slides.length - 1;
    if (targetIndex >= swiper.slides.length) targetIndex = 0;
    hydrateDeferredSlideImages(swiper.slides[targetIndex]);
  }
  /* [End] */

  return {
    init: function (scope) {
      this.BlsSettingsCarousel(scope || document);
    },
    BlsSettingsCarousel: function (scope) {
      var _this = this;
      var initializeImmediately =
        !("IntersectionObserver" in window) ||
        Boolean(window.Shopify && window.Shopify.designMode);

      collectCarousels(scope).forEach((element) => {
        if (isInitialized(element)) return;

        if (initializeImmediately || element.dataset.slideshow) {
          _this.BlsCarousel(element);
          return;
        }

        if (!carouselObserver) {
          carouselObserver = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                observer.unobserve(entry.target);
                if (entry.target.dataset.vedressSwiperScheduled === "true") return;
                entry.target.dataset.vedressSwiperScheduled = "true";

                var initialize = () => {
                  delete entry.target.dataset.vedressSwiperScheduled;
                  if (!entry.target.isConnected) return;
                  _this.BlsCarousel(entry.target);
                };

                /* [Modified by Codex at 2026-09-12] 避免非首屏轮播在 LCP 阶段被超时强制执行 */
                window.requestAnimationFrame(() => {
                  if ("requestIdleCallback" in window) {
                    window.requestIdleCallback(initialize);
                  } else {
                    window.requestAnimationFrame(initialize);
                  }
                });
                /* [End] */
              });
            },
            /* [Modified by Codex at 2026-09-12] 收紧轮播预激活范围以保护首屏主线程 */
            { rootMargin: "100px 0px" },
            /* [End] */
          );
        }

        carouselObserver.observe(element);
      });
    },
    BlsCarousel: function (e) {
      if (isInitialized(e)) return e?.swiper;

      e.dataset.vedressSwiperInitialized = "true";
      var sliderGlobal;
      var autoplaying = e?.dataset.autoplay === "true";
      var loop = e?.dataset.loop === "true";
      var dataSlideshow = e?.dataset.slideshow ? e?.dataset.slideshow : 0;
      var dataBanner = e?.dataset.banner ? e?.dataset.banner : 0;
      var dataImageIcon = e?.dataset.imageIcon ? e?.dataset.imageIcon : 0;
      var dataCollection = e?.dataset.collection ? e?.dataset.collection : 0;
      var dataArrowCenterImage = e?.dataset.arrowCenterimage
        ? e?.dataset.arrowCenterimage
        : 0;
      var itemDesktop = e?.dataset.desktop ? e?.dataset.desktop : 4;
      var itemTablet = e?.dataset.tablet ? e?.dataset.tablet : 2;
      var itemMobile = e?.dataset.mobile ? e?.dataset.mobile : 1;
      var itemSmallMobile = e?.dataset.smallMobile ? e?.dataset.smallMobile : 1;
      var autoplaySpeed = e?.dataset.autoplaySpeed
        ? e?.dataset.autoplaySpeed
        : 3000;
      var speed = e?.dataset.speed ? e?.dataset.speed : 400;
      var effect = e?.dataset.effect ? e?.dataset.effect : "slide";
      var row = e?.dataset.row ? e?.dataset.row : 1;
      var spacing = e?.dataset.spacing ? e?.dataset.spacing : 0;
      var progressbar = e?.dataset.paginationProgressbar === "true";
      var autoItem = e?.dataset.itemMobile === "true";
      spacing = Number(spacing);
      autoplaySpeed = Number(autoplaySpeed);
      speed = Number(speed);
      if (autoplaying) {
        var autoplaying = { delay: autoplaySpeed };
      }
      try {
        sliderGlobal = new Swiper(e, {
          slidesPerView: autoItem
            ? "auto"
            : dataCollection
              ? itemSmallMobile
              : itemMobile,
          spaceBetween: spacing >= 15 ? 15 : spacing,
          autoplay: autoplaying,
          loop: loop,
          effect: effect,
          speed: speed,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          grid: {
            rows: row,
            fill: "row",
          },
          navigation: {
            nextEl: dataBanner
              ? e.querySelector(".swiper-arrow-next")
              : e.querySelector(".swiper-button-next"),
            prevEl: dataBanner
              ? e.querySelector(".swiper-arrow-prev")
              : e.querySelector(".swiper-button-prev"),
          },
          pagination: {
            clickable: true,
            el: e.querySelector(".swiper-pagination"),
            type: progressbar ? "progressbar" : "bullets",
          },
          breakpoints: {
            576: {
              slidesPerView: dataImageIcon ? itemTablet : itemMobile,
            },
            768: {
              slidesPerView: itemTablet,
              spaceBetween: spacing >= 30 ? 30 : spacing,
            },
            1200: {
              slidesPerView: itemDesktop,
              spaceBetween: spacing,
            },
          },
          on: {
            init: function () {
              if (!dataArrowCenterImage) return;

              /* [Modified by Codex at 2026-09-12] 分离轮播尺寸读取与样式写入以减少强制回流 */
              var swiperElement = e;
              var responsiveImages = Array.from(
                swiperElement.querySelectorAll(".bls__responsive-image"),
              );
              if (!responsiveImages.length) return;

              var arrowWriteFrame;

              function writeArrowOffset(imageHeight) {
                if (!imageHeight) return;

                window.cancelAnimationFrame(arrowWriteFrame);
                arrowWriteFrame = window.requestAnimationFrame(() => {
                  if (!swiperElement.isConnected) return;
                  swiperElement.style.setProperty(
                    "--arrows-offset-top",
                    imageHeight / 2 + "px",
                  );
                });
              }

              if ("ResizeObserver" in window) {
                var observedHeights = new Map();
                var arrowResizeObserver = new ResizeObserver((entries) => {
                  entries.forEach((entry) => {
                    observedHeights.set(entry.target, entry.contentRect.height);
                  });

                  writeArrowOffset(Math.max(...observedHeights.values()));
                });

                responsiveImages.forEach((image) => {
                  arrowResizeObserver.observe(image);
                });
                swiperElement.vedressArrowResizeObserver = arrowResizeObserver;
              } else {
                var resizeTimeout;

                function measureArrowOffset() {
                  window.requestAnimationFrame(() => {
                    var maxHeight = 0;
                    responsiveImages.forEach((image) => {
                      maxHeight = Math.max(
                        maxHeight,
                        image.getBoundingClientRect().height,
                      );
                    });
                    writeArrowOffset(maxHeight);
                  });
                }

                measureArrowOffset();
                window.addEventListener(
                  "resize",
                  () => {
                    window.clearTimeout(resizeTimeout);
                    resizeTimeout = window.setTimeout(measureArrowOffset, 100);
                  },
                  { passive: true },
                );
                if (document.readyState === "complete") {
                  measureArrowOffset();
                } else {
                  window.addEventListener("load", measureArrowOffset, {
                    once: true,
                  });
                }
              }
              /* [End] */
            },
          },
        });
      } catch (error) {
        delete e.dataset.vedressSwiperInitialized;
        throw error;
      }

      if (dataSlideshow) {
        /* [Modified by Codex at 2026-10-12] 操作前准备目标横幅，并在销毁时清理事件 */
        var imagePrepareListeners = [];

        function bindImagePrepare(target, eventName, handler) {
          if (!target) return;
          target.addEventListener(eventName, handler, { passive: true });
          imagePrepareListeners.push({ target, eventName, handler });
        }

        var nextButton = e.querySelector(".swiper-button-next");
        var previousButton = e.querySelector(".swiper-button-prev");
        ["pointerenter", "pointerdown"].forEach((eventName) => {
          bindImagePrepare(nextButton, eventName, () => hydrateAdjacentSlide(sliderGlobal, 1));
          bindImagePrepare(previousButton, eventName, () => hydrateAdjacentSlide(sliderGlobal, -1));
        });

        bindImagePrepare(e.querySelector(".swiper-pagination"), "pointerdown", (event) => {
          var bullet = event.target.closest(".swiper-pagination-bullet");
          if (!bullet) return;
          var bullets = Array.from(bullet.parentElement.children);
          var index = bullets.indexOf(bullet);
          Array.from(sliderGlobal.slides).forEach((slide) => {
            if (Number(slide.dataset.swiperSlideIndex) === index) {
              hydrateDeferredSlideImages(slide);
            }
          });
        });

        sliderGlobal.on("sliderFirstMove", function (swiper, event) {
          var pointer = event?.targetTouches?.[0] || event;
          var delta = (pointer?.pageX ?? swiper.touches.currentX) - swiper.touches.startX;
          var offset = delta > 0 ? -1 : 1;
          hydrateAdjacentSlide(swiper, swiper.rtlTranslate ? -offset : offset);
        });

        if (window.Shopify?.designMode) {
          bindImagePrepare(document, "shopify:block:select", (event) => {
            var slide = event.target.closest?.(".swiper-slide");
            if (!slide || !e.contains(slide)) return;
            hydrateDeferredSlideImages(slide);
            sliderGlobal.slideToLoop(Number(slide.dataset.swiperSlideIndex));
          });
          bindImagePrepare(document, "shopify:section:unload", (event) => {
            var ownsTarget = event.target !== document && event.target.contains?.(e);
            var ownsSectionId = e.dataset.sectionId &&
              e.dataset.sectionId === event.detail?.sectionId;
            if (ownsTarget || ownsSectionId) sliderGlobal.destroy();
          });
        }

        sliderGlobal.on("destroy", function () {
          delete e.dataset.vedressSwiperInitialized;
          imagePrepareListeners.forEach(({ target, eventName, handler }) => {
            target.removeEventListener(eventName, handler);
          });
          imagePrepareListeners = [];
          Array.from(sliderGlobal.slides).forEach((slide) => {
            slide.querySelectorAll("img").forEach((image) => image.vedressSlideImageCleanup?.());
          });
        });
        /* [End] */

        /* [Modified by Codex at 2026-10-12] 自动切换与分页切换时启用当前横幅真实图片 */

        sliderGlobal.on("slideChange", function () {
          hydrateDeferredSlideImages(sliderGlobal.slides[sliderGlobal.activeIndex]);
          document.querySelectorAll(".video-slider").forEach((video) => {
            var dataVideo = video.dataset.video;
            var dataPoster = video.dataset.poster;
            video.innerHTML = `
              <video playsinline="true" loop="loop" muted="muted" autoplay="autoplay" preload="metadata"
                poster="${dataPoster}">
                <source
                  src="${dataVideo}"
                  type="video/mp4">
              </video>
              `;
          });
        });
        /* [End] */
      }

      if (dataBanner) {
        sliderGlobal.on("slideChange", function () {
          BlsLazyloadImg.init();
        });
      }

      return sliderGlobal;
    },
  };
})();
BlsSettingsSwiper.init();
/* [End] */
